// Картата на една корекция на телефон. Общата транспозиция „ред на колона"
// би направила от 10 колони карта от 10 реда — на екран влиза един запис.
// Тук първият ред носи това, което човек търси: коя сметка и колко е отнето.

import {
  EM_DASH,
  formatDateTime,
  formatPercent,
} from "../../../../components/dataTable";
import { fmtEuro } from "../../../../utils/currency";
import type { NamedDiscountRow } from "./discountsMath";

/** Минус знак U+2212 — както в колоната „Отстъпка". */
const MINUS = "−";

export const DiscountsMobileCard = ({ row }: { row: NamedDiscountRow }) => {
  const closed = formatDateTime(row.closed_at, true);
  const isDiscount = row.adjustment < 0;

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-2">
        <span className="min-w-0 flex-1 truncate text-[15px] font-bold text-ink">
          {row.billLabel}
        </span>
        <span
          className={`font-pos-mono text-[15px] font-bold tabular-nums ${
            isDiscount ? "text-danger-ink" : "text-info-deep"
          }`}
        >
          {isDiscount
            ? `${MINUS}${fmtEuro(-row.adjustment)}`
            : `+${fmtEuro(row.adjustment)}`}
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[12px] font-medium text-muted">
        <span className="font-pos-mono tabular-nums">{closed.time}</span>
        {closed.date ? (
          <span className="font-pos-mono tabular-nums">{closed.date}</span>
        ) : null}
        <span aria-hidden>·</span>
        <span className="truncate">{row.waiterLabel || EM_DASH}</span>
        <span aria-hidden>·</span>
        <span className="font-pos-mono tabular-nums">
          {formatPercent(row.percentAbs, 1, true)}
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[12px] font-medium text-soft">
        <span>{row.kindLabel}</span>
        {row.clientLabel ? (
          <>
            <span aria-hidden>·</span>
            <span className="truncate">{row.clientLabel}</span>
          </>
        ) : null}
        <span aria-hidden>·</span>
        <span className="font-pos-mono tabular-nums">{fmtEuro(row.paid)}</span>
      </div>
    </div>
  );
};
